import { useContext, useMemo, useState } from "react";
import { useFieldArray } from "react-hook-form";

import { CPagination, CTable } from "src/common/components/others";
import { formatSearchString } from "src/utils/funcs";

import { SearchContext } from ".";

export const TabGoodsTable = ({ control, priceType }) => {
  //#region Data
  const { searchValue } = useContext(SearchContext);

  const { fields: fieldsForm } = useFieldArray({
    control,
    name: `goods.${priceType}`,
    keyName: "__id",
  });

  const visibleData = useMemo(() => {
    if (!fieldsForm) return [];
    const searchString = formatSearchString(searchValue);
    return fieldsForm.filter(
      (e) =>
        formatSearchString(e.code).includes(searchString) ||
        formatSearchString(e.name).includes(searchString),
    );
  }, [searchValue, fieldsForm]);

  const [paginate, setPaginate] = useState({ page: 1, limit: 10 });
  //#endregion

  //#region Event
  const onPageChange = (newPaginate) => {
    setPaginate(newPaginate);
  };
  //#endregion

  //#region Render
  const fields = [
    { key: "code", label: "Mã HH", _style: { textAlign: "left" } },
    { key: "name", label: "Tên Hàng Hóa", _style: { textAlign: "left" } },
    { key: "formula_unit", label: "Đơn vị tính" },
    { key: "price", label: "Giá bán", _style: { textAlign: "right" } },
  ];
  const render = {
    code: ({ code }) => <td className="text-left">{code}</td>,
    name: ({ name }) => <td className="text-left">{name}</td>,
    price: ({ price }) => (
      <td className="text-right">{(price ?? 0)?.toLocaleString("en-US")}</td>
    ),
  };
  return (
    <CTable
      tableBgColor="#f6f7f7"
      data={visibleData}
      page={paginate.page}
      itemsPerPage={paginate.limit}
      fields={fields}
      render={render}
      footer={
        <CPagination
          page={paginate.page}
          total={visibleData?.length}
          limit={paginate.limit}
          onPaginationChange={onPageChange}
        />
      }
    />
  );
  //#endregion
};
